<template>
        <div class="row">
            <div class="col-12 col-lg-6">
                <a id="kirche"></a>
                <img src="../assets/obpfar.jpg" alt="Logo Theresa und Paul" class="obpfar" />
                <div class="flexmargin">
                    <h4><span>Unsere Liebe Frau</span> (Obere Pfarre)</h4>
                    <p>Frauenplatz<br>96049 Bamberg<br><a href="https://kirche-obere-pfarre-bamberg.de/" target="_blank">kirche-obere-pfarre-bamberg.de</a></p>
                    <p>Da es keine Parkmöglichkeiten in direkter Umgebung der Kirche gibt, empfehlen wir euch, entweder per ÖPNV bis Bushaltestelle Schulplatz zu fahren oder z. B. in der <a href="https://www.bamberg.info/poi/tiefgarage_city-altstadt-4977/" target="_blank" rel="noopener noreferrer">Tiefgarage Geyerswörth</a> zu parken.</p>
                    <p><em>Achtung: Für den Freitag sind <span style="dick">ganztägig Warnstreiks im ÖPNV</span> angekündigt worden, die auch in Bamberg stattfinden sollen.</em> Solltet ihr ein Taxi benötigen, so könnt ihr z. B. in der Taxi-Zentrale anrufen (<a href="tel:+4995115015">0951 15015</a> - <a href="https://www.taxi-bamberg.de" target="_blank" rel="noopener noreferrer">www.taxi-bamberg.de</a> )</p>
                    
                    <h4>Ablauf</h4>
                    <p>Neben der Sakristei gibt es ein Gebäude mit Toiletten im Erdgeschoss (von der Straße abgewandte Seite der Kirche; das Gebäude hat eine Rampe). Hier befindet sich auch ein Wickelraum. Das Gebäude wird circa eine Stunde vor dem Gottesdienst aufgeschlossen.</p>
                    <p>Bitte begebt euch bereits vor 14 Uhr in die Kirche. Die Ordner oder unsere Trauzeugen werden euch bei der Platzwahl behilflich sein. Von ihnen erhaltet ihr auch das Liedheft.</p>
                    <p>Es wird keine Kollekte während des Gottesdienstes geben. Ihr seid eingeladen, beim Verlassen der Kirche etwas in das ausliegende Kollektekörbchen zum Erhalt der Oberen Pfarre zu geben.</p>

                    <a id="corona"></a>
                    <h4>Corona-Regeln</h4>
                    <p>Die Lage kann sich aktuell täglich ändern und wir aktualisieren die Seite regelmäßig. Wir wollen in entspannter Atmosphäre feiern und gleichzeitig die AHA-Regel (Abstand halten – Hygiene beachten – Alltagsmaske tragen) beachten.</p>
                    <p>Die Kirche darf ausschließlich über das Hauptportal betreten werden. Dort befinden sich auch die Desinfektionsspender. Die Seitenportale dienen als Ausgänge. Diese Wegführung gilt auch, wenn ihr <em>nur kurz</em> raus gehen wollt.</p>
                    <p>In der Kirche gibt es gekennzeichnete Sitzplätze (pro Sitzplatzfläche ein Haushalt/Paar/Familie). Dort gilt das Tragen eines Mund-Nasen-Schutzes. Sobald man sitzt, kann man die Maske abnehmen.</p>
                </div>
            </div>
            <div class="col-12 col-lg-6">
                <a id="restaurant"></a>
                <img src="../assets/dafra.jpg" alt="Logo Theresa und Paul" class="obpfar" />
                <div class="flexmargin">
                    <h4>Ristorante da Francesco</h4>
                    <p>Michelsberg 10f<br>96049 Bamberg<br><a href="https://www.francesco-bamberg.de/" target="_blank">www.francesco-bamberg.de</a></p>
                    <p>Auch hier empfehlen wir euch mit dem Taxi oder dem ÖPNV anzureisen. Es gibt einige Parkplätze am Kloster Michelsberg. Den Parkzettel könnt ihr im Restaurant entwerten lassen. Denkt bitte daran, dies erst kurz bevor ihr fahrt zu tun.</p>
                    <p><em>Achtung: Für den Freitag sind <strong>ganztägig</strong> Warnstreiks im ÖPNV angekündigt worden, die auch in Bamberg stattfinden sollen.</em> Solltet ihr ein Taxi benötigen, so könnt ihr z. B. in der Taxi-Zentrale anrufen (<a href="tel:+4995115015">0951 15015</a> - <a href="https://www.taxi-bamberg.de" target="_blank" rel="noopener noreferrer">www.taxi-bamberg.de</a> )</p>

                    <h4>Corona-Hinweise</h4>
                    <p>Nach aktuellem Stand (4. Oktober) gibt es im Restaurant keine Pflicht für das Tragen eines Mund-Nasen-Schutzes, es steht jedoch natürlich jedem frei. Obwohl wir im Restaurant eine „geschlossene Gesellschaft“ sind, nehmen wir die geltenden Hygienevorschriften ernst, beispielsweise durch regelmäßiges Lüften.</p>

                    <h4>Weitere Hinweise</h4>
                    <p>Im ersten Stock des Restaurants gibt es einen Raum, in dem ihr in Ruhe stillen könnt.</p>
                </div>
            </div>
        </div>
</template>

<script>
export default {
    name: 'Infos'
}
</script>

<style lang="scss">
@import "~bootstrap";

.obpfar {
    width: 100%;
    margin-bottom: 1rem;
}

@include media-breakpoint-down(md) {
    .flexmargin {
        margin: 0 1rem;
    }
}
</style>
